 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {commitLocalUpdate, usePreloadedQuery} from 'react-relay'

import useAtmosphere from '../hooks/useAtmosphere'

import SearchQueryId from '../shared/gqlIds/SearchQueryId'
import getReposFromQueryStr from '../utils/getReposFromQueryStr'
import GitHubRepoSearchFilterMenu from './GitHubRepoSearchFilterMenu'












const GitHubScopingSearchFilterMenu = (props) => {
  const {menuProps, queryRef} = props
  const query = usePreloadedQuery(
    graphql`
      query GitHubScopingSearchFilterMenuQuery($teamId: ID!, $meetingId: ID!) {
        viewer {
          meeting(meetingId: $meetingId) {
            id
            ... on PokerMeeting {
              githubSearchQuery {
                queryString
              }
            }
          }
          teamMember(teamId: $teamId) {
            ...GitHubRepoSearchFilterMenu_teamMember
          }
        }
      }
    `,
    queryRef
  )

  const meeting = _optionalChain([query, 'optionalAccess', _ => _.viewer, 'optionalAccess', _2 => _2.meeting])
  const meetingId = _nullishCoalesce(_optionalChain([meeting, 'optionalAccess', _3 => _3.id]), () => ( ''))
  const githubSearchQuery = _optionalChain([meeting, 'optionalAccess', _4 => _4.githubSearchQuery])
  const queryString = _nullishCoalesce(_optionalChain([githubSearchQuery, 'optionalAccess', _5 => _5.queryString]), () => ( null))
  const atmosphere = useAtmosphere()
  const selectedRepos = getReposFromQueryStr(queryString)

  return (
    React.createElement(GitHubRepoSearchFilterMenu, {
      selectedRepos: selectedRepos,
      onToggleRepo: (repo, isSelected) => {
        commitLocalUpdate(atmosphere, (store) => {
          const searchQueryId = SearchQueryId.join('github', meetingId)
          const githubSearchQuery = store.get(searchQueryId)
          const newFilters = isSelected
            ? selectedRepos.filter((name) => name !== repo)
            : selectedRepos.concat(repo)
          const queryString = githubSearchQuery.getValue('queryString')
          const queryWithoutRepos = queryString
            .trim()
            .split(' ')
            .filter((str) => !str.includes('repo:'))
          const newRepos = newFilters.map((name) => `repo:${name}`)
          const newQueryStr = queryWithoutRepos.concat(newRepos).join(' ')
          githubSearchQuery.setValue(newQueryStr, 'queryString')
        })
      },
      teamMemberRef: query.viewer.teamMember,
      menuProps: menuProps,}
    )
  )
}

export default GitHubScopingSearchFilterMenu
